import { render, staticRenderFns } from "./DataConsent.vue?vue&type=template&id=856a3f10&scoped=true&"
import script from "./DataConsent.vue?vue&type=script&lang=js&"
export * from "./DataConsent.vue?vue&type=script&lang=js&"
import style0 from "./DataConsent.vue?vue&type=style&index=0&id=856a3f10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "856a3f10",
  null
  
)

export default component.exports